import { useCallback, useEffect } from 'react';

import { CONSTANTS } from 'config/envVariables';
import { logError } from 'lib/sentry/logError';
import { useEventListener } from 'usehooks-ts';

import { useGetAccessToken } from 'features/auth/hooks/useGetAccessToken';
import { useIsCoachMode } from 'features/user/hooks/useIsCoachMode';

export const useSendJWTTokenToExtension = () => {
  const isCoachMode = useIsCoachMode();
  const getAccessToken = useGetAccessToken();

  // @ts-ignore
  const hosIncStoreExtensionId = CONSTANTS.HOS_INC_STORE_EXTENSION_ID;

  const sendJwtToken = useCallback(async () => {
    // @ts-ignore
    const chromeInstance = window.chrome;
    if (!chromeInstance?.runtime) {
      return;
    }
    const token = await getAccessToken();

    try {
      chromeInstance.runtime.sendMessage(hosIncStoreExtensionId, {
        jwt: token,
      });
    } catch (error) {
      logError(`Error sending JWT token to hos inc store extension: ${error}`);
    }
  }, [getAccessToken, hosIncStoreExtensionId]);

  useEffect(() => {
    if (isCoachMode) {
      sendJwtToken();
    }
  }, [sendJwtToken, isCoachMode]);

  const windowFocusHandler = useCallback(() => {
    if (isCoachMode) {
      sendJwtToken();
    }
  }, [sendJwtToken, isCoachMode]);

  useEventListener('focus', windowFocusHandler);
};
